import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'is',
  months: [
    'janúar',
    'febrúar',
    'mars',
    'apríl',
    'maí',
    'júní',
    'júlí',
    'ágúst',
    'september',
    'október',
    'nóvember',
    'desember',
  ],
  monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maí', 'jún.', 'júl.', 'ágú.', 'sep.', 'okt.', 'nóv.', 'des.'],
  weekdays: ['sunnudagur', 'mánudagur', 'þriðjudagur', 'miðvikudagur', 'fimmtudagur', 'föstudagur', 'laugardagur'],
  weekdaysMin: ['S', 'M', 'Þ', 'M', 'F', 'F', 'L'],
  weekdaysShort: ['sun.', 'mán.', 'þri.', 'mið.', 'fim.', 'fös.', 'lau.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D.M.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY, HH:mm',
    'LLL-Y': 'D. MMMM, HH:mm',
    LLLL: 'dddd, D. MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D. MMMM, HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M.',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    lll: 'D. MMM YYYY, h:mm A',
    'lll-Y': 'D. MMM, h:mm A',
    llll: 'ddd, D. MMM YYYY, h:mm A',
    'llll-Y': 'ddd, D. MMM, h:mm A',
    'll-Y+w': 'ddd, D. MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'f.h.', pm: 'e.h.', AM: 'f.h.', PM: 'e.h.' },
  past: {
    y: { one: 'fyrir %s ári', other: 'fyrir %s árum' },
    M: { one: 'fyrir %s mán.', other: 'fyrir %s mán.' },
    w: { one: 'fyrir %s viku', other: 'fyrir %s vikum' },
    d: { one: 'fyrir %s degi', other: 'fyrir %s dögum' },
    h: { one: 'fyrir %s klst.', other: 'fyrir %s klst.' },
    m: { one: 'fyrir %s mín.', other: 'fyrir %s mín.' },
    s: { one: 'fyrir %s sek.', other: 'fyrir %s sek.' },
  },
  future: {
    y: { one: 'eftir %s ár', other: 'eftir %s ár' },
    M: { one: 'eftir %s mán.', other: 'eftir %s mán.' },
    w: { one: 'eftir %s viku', other: 'eftir %s vikur' },
    d: { one: 'eftir %s dag', other: 'eftir %s daga' },
    h: { one: 'eftir %s klst.', other: 'eftir %s klst.' },
    m: { one: 'eftir %s mín.', other: 'eftir %s mín.' },
    s: { one: 'eftir %s sek.', other: 'eftir %s sek.' },
  },
  abbr: {
    y: { one: '%s ár', other: '%s ár' },
    M: { one: '%s mán.', other: '%s mán.' },
    w: { one: '%s vika', other: '%s vikur' },
    d: { one: '%s dagur', other: '%s dagar' },
    h: { one: '%s klst.', other: '%s klst.' },
    m: { one: '%s mín.', other: '%s mín.' },
    s: { one: '%s sek.', other: '%s sek.' },
  },
  justNow: 'núna',
  yesterday: 'í gær',
  today: 'í dag',
  tomorrow: 'á morgun',
  weekStart: 1,
};
const localeName: LocaleName = 'is';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'f.h.' : 'f.h.';
    } else {
      return isLowerCase ? 'e.h.' : 'e.h.';
    }
  },
};
